import { render, staticRenderFns } from "./ProdoutosTabela.vue?vue&type=template&id=42537bd6"
import script from "./ProdoutosTabela.vue?vue&type=script&lang=js"
export * from "./ProdoutosTabela.vue?vue&type=script&lang=js"
import style0 from "./ProdoutosTabela.vue?vue&type=style&index=0&id=42537bd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports